import * as React from 'react';

const SvgDownloadOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M10.963 13.164V3h2v10.171l3.585-3.585L17.96 11l-5.998 6-6.002-6.033 1.418-1.41 3.584 3.607Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 7V5h6v16H2V5h6v2H4v12h16V7h-4Z", fill: "currentColor" })));

export { SvgDownloadOutline as default };
